module.exports = __webpack_public_path__ + "static/img/logo.6432b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/TCE-AL/logo.png
// module id = bHm5
// module chunks = 1